const mainHeader = document.querySelector('.main-header');
const megamenuToggle = document.querySelector('.js-toggle-megamenu');
const megamenuSection = document.querySelector('.js-megamenu');
const menuItems = megamenuSection.querySelectorAll('.js-has-submenu');
const groupItems = megamenuSection.querySelectorAll('.js-group');

let expandedItem = null;
let expandedMobileMenu = false;
let collapseTimeout;

const expandSubMenu = (item, focusVisible = false) => {
    if (expandedItem) {
        collapseSubMenu(expandedItem);
    }
    const subMenu = item.querySelector('.js-submenu');
    const button = item.querySelector('.js-toggle-submenu');
    expandedItem = item;

    subMenu.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
    item.dataset.expanded = 'true';
    if (focusVisible) {
        subMenu.querySelectorAll('a')[0].focus({ focusVisible }); // Focus on the first link in the submenu
    }
};

const collapseSubMenu = (item, focusVisible = false) => {
    const subMenu = item.querySelector('.js-submenu');
    const button = item.querySelector('.js-toggle-submenu');
    expandedItem = null;

    subMenu.setAttribute('aria-hidden', 'true');
    button.setAttribute('aria-expanded', 'false');
    item.dataset.expanded = 'false';
    if (focusVisible) {
        button.focus({ focusVisible }); // Focus back on the button
    }
};

const expandGroup = (item, focusVisible = false) => {
    const body = item.querySelector('.js-group-body');
    const button = item.querySelector('.js-toggle-group');

    button.setAttribute('aria-expanded', 'true');
    item.dataset.expanded = 'true';
    if (focusVisible) {
        body.querySelectorAll('a')[0].focus({ focusVisible }); // Focus on the first link in the group
    }
};

const collapseGroup = (item, focusVisible = false) => {
    const button = item.querySelector('.js-toggle-group');

    button.setAttribute('aria-expanded', 'false');
    item.dataset.expanded = 'false';
    if (focusVisible) {
        button.focus({ focusVisible }); // Focus back on the button
    }
};

const toggleMegamenuMobile = (focusVisible = false) => {
    const mainHeaderRect = mainHeader.getBoundingClientRect();
    megamenuSection.style.top = mainHeaderRect.bottom + 'px';
    megamenuSection.classList.toggle('open');
    document.body.classList.toggle('megamenu-open');
    megamenuToggle.setAttribute(
        'aria-expanded',
        megamenuSection.classList.contains('open')
    );
    expandedMobileMenu = megamenuSection.classList.contains('open');
    if (expandedMobileMenu) {
        megamenuSection.querySelectorAll('a')[0].focus({ focusVisible }); // Focus on the first link in the menu
    } else {
        megamenuToggle.focus({ focusVisible }); // Focus back on the toggle button
    }
    if (expandedItem) {
        collapseSubMenu(expandedItem); // Collapse any expanded submenu when closing the megamenu
    }
};

megamenuToggle.addEventListener('click', () => toggleMegamenuMobile());
megamenuToggle.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleMegamenuMobile(true);
    }
});

menuItems.forEach((item) => {
    const subMenu = item.querySelector('.js-submenu');
    const button = item.querySelector('.js-toggle-submenu');
    const backButton = item.querySelector('.js-back-submenu');

    button.addEventListener('click', (event) => {
        if (button.getAttribute('aria-expanded') === 'false') {
            expandSubMenu(item);
        } else {
            collapseSubMenu(item);
        }
    });
    
    backButton.addEventListener('click', (event) => {
        collapseSubMenu(item);
    });
    
    item.addEventListener('mouseenter', () => {
        clearTimeout(collapseTimeout);
        expandSubMenu(item);
    });
    
    item.addEventListener('mouseleave', (event) => {
        if (item.contains(event.relatedTarget)) return;
        collapseTimeout = setTimeout(() => { collapseSubMenu(item); }, 300);
    });
    
    subMenu.addEventListener('mouseleave', (event) => {
        if (item.contains(event.relatedTarget)) return;
        collapseTimeout = setTimeout(() => { collapseSubMenu(item); }, 300);
    });

    button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Prevent the default action to stop scrolling when pressing Space
            if (button.getAttribute('aria-expanded') === 'false') {
                expandSubMenu(item, true);
            } else {
                collapseSubMenu(item, true);
            }
        }
    });
    
    backButton.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Prevent the default action to stop scrolling when pressing Space
            collapseSubMenu(item, true);
        }
    });
});

document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
        if (!expandedItem) {
            if (expandedMobileMenu) {
                const focusedElement = document.querySelector(':focus');
                const focusableElements = megamenuSection.querySelectorAll('a');
                const firstFocusableElement = focusableElements[0];
                const lastFocusableElement =
                    focusableElements[focusableElements.length - 1];
                if (
                    !event.shiftKey &&
                    focusedElement === lastFocusableElement
                ) {
                    event.preventDefault(); // Prevent the default action to move focus programmatically
                    toggleMegamenuMobile(true);
                }

                if (
                    event.shiftKey &&
                    focusedElement === firstFocusableElement
                ) {
                    event.preventDefault(); // Prevent the default action to move focus programmatically
                    toggleMegamenuMobile(true);
                }
            }
            return;
        }

        const subMenu = expandedItem.querySelector('.js-submenu');

        const focusedElement = expandedItem.querySelector(':focus');
        const focusableElements = Array.from(
            subMenu.querySelectorAll('a, .js-toggle-group')
        ).filter((el) => getComputedStyle(el).display !== 'none');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement =
            focusableElements[focusableElements.length - 1];

        if (!event.shiftKey && focusedElement === lastFocusableElement) {
            event.preventDefault(); // Prevent the default action to move focus programmatically
            collapseSubMenu(expandedItem, true);
        }

        if (event.shiftKey && focusedElement === firstFocusableElement) {
            event.preventDefault(); // Prevent the default action to move focus programmatically
            collapseSubMenu(expandedItem, true);
        }
    }

    if (event.key == 'Escape') {
        if (expandedItem) {
            collapseSubMenu(expandedItem, true);
        } else if (expandedMobileMenu) {
            toggleMegamenuMobile(true);
        }
    }
});

groupItems.forEach((item) => {
    const button = item.querySelector('.js-toggle-group');

    if (button) {
        button.addEventListener('click', (event) => {
            if (button.getAttribute('aria-expanded') === 'false') {
                expandGroup(item);
            } else {
                collapseGroup(item);
            }
        });

        button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault(); // Prevent the default action to stop scrolling when pressing Space
                if (button.getAttribute('aria-expanded') === 'false') {
                    expandGroup(item, true);
                } else {
                    collapseGroup(item, true);
                }
            }
        });
    }
});
